import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Route, Router } from '@angular/router';
import { BehaviorSubject, debounceTime, distinctUntilChanged, fromEvent, takeUntil, tap } from 'rxjs';
import { LookupModel } from '../../../models/common/lookup.model';
import { HttpErrorHandlerService } from '../../../services/http-error-handler.service';
import { NotificationsService } from '../../../services/notifications.service';
import { BaseUnsubscribeComponent } from '../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { NotificationTypeDto } from '../../../shared-new/enums/notification-type.enum';
import { NotificationTypeListDataSource } from './notification-type.datasource';


@Component({
  selector: 'app-notification-type-list',
  templateUrl: './notification-type-list.component.html',
  styleUrls: ['./notification-type-list.component.scss']
})
export class NotificationTypeListComponent extends BaseUnsubscribeComponent implements AfterViewInit {
  notificationTypes: NotificationTypeDto[] = [];
  groups: LookupModel[] = [];
  selectedGroup: number | null = null;
  groupMap: Map<number, string> = new Map();
  dataSource: NotificationTypeListDataSource;
  displayedColumns$ = new BehaviorSubject([
    'name',
    'description',
    'notificationMethod',
    'defaultEmailSubject',
    'defaultSMSText',
    'tagLegend',
    'action'
  ]);
  @ViewChild(MatSort) sort: MatSort;
  public searchTerm: string;

  constructor(private readonly notificationService: NotificationsService, private readonly route: Router, private httpError: HttpErrorHandlerService) {
    super();
  }

  goToEdit(row: NotificationTypeDto): void {
    this.route.navigateByUrl(`/notification-type-modify/${row.notificationTypeId}`);
  }

  ngAfterViewInit(): void {
    this.notificationService.getAllNotificationTypes().subscribe({
      next: (data) => {
        this.notificationTypes = data;
        setTimeout(() => {
          this.dataSource = new NotificationTypeListDataSource(this.notificationTypes, this.sort);

          if (this.searchTerm) {
            this.dataSource.searchTable(this.searchTerm);
          }
        }, 100);
      },
      error: (err) => this.httpError.ShowErrorMessage(err)
    });
  }
  applyFilter(searchText: string) {
    this.searchTerm = searchText;
    this.dataSource.searchTable(searchText);
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  trackById(index: number, item: NotificationTypeDto): any {
    return item.notificationTypeId;
  }


}
